// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sdU9a","signatureBlock":"Footer_signatureBlock__15ZA3","signature":"Footer_signature__1wemU"};